// src/data.js
const documDetails = [
    {
      name: 'consent',
      isSigned: false,
    },
    {
      name: 'joboffer',
      isSigned: false,
    },
    // Add more entries as needed
  ];
  
  export default documDetails;
  